import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { createContext } from 'react';

var _createContext = createContext({
  isOpen: true,
  onExited: undefined
}),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

// checks if children exist and are truthy


var hasChildren = function hasChildren(children) {
  return React.Children.count(children) > 0 && React.Children.map(children, function (child) {
    return !!child;
  }).filter(Boolean).length > 0;
};

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Transition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Transition.__proto__ || _Object$getPrototypeOf(Transition)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      currentChildren: undefined
    }, _this.onExited = function () {
      _this.setState({
        currentChildren: _this.props.children
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Transition, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        Provider,
        {
          value: {
            onExited: this.onExited,
            isOpen: hasChildren(this.props.children)
          }
        },
        this.state.currentChildren
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props, state) {
      var previousChildren = state.currentChildren;

      var exiting = hasChildren(previousChildren) && !hasChildren(props.children);
      return {
        currentChildren: exiting ? previousChildren : props.children
      };
    }
  }]);

  return Transition;
}(React.Component);

export var ModalTransitionConsumer = Consumer;

export default Transition;